window.Page = {

    // Let's launch this thing
    liftoff : () => {
        Page.Slider.init()
    },

    // All the slider related functions
    Slider : {
        
        container : document.querySelector('.slides'),

        firstSlide   : document.querySelector('.slide:first-child'),
        lastSlide    : document.querySelector('.slide:first-child'),
        activeSlide  : document.querySelector('.slide-active'),
        activeNumber : document.querySelector('.slider-number-active'),

        nextButton  : document.querySelector('.slider-next'),
        prevButton  : document.querySelector('.slider-prev'),
        sliderArrow : document.querySelector('.slider-arrow'),

        sliderTitle   : document.querySelector('.slider-title'),
        sliderTrack   : [...document.querySelectorAll('.slide')],
        sliderNumbers : [...document.querySelectorAll('.slider-number')],
        sliderIndex   : 0,

        init : () => {
            Page.Slider.moveSliderWithNumbers()
            Page.Slider.moveSliderForwardOnClick()
            Page.Slider.moveSliderBackwardsOnClick()
            Page.Slider.swipeEvents()
        },

        updateSliderTitle : () => {
            Page.Slider.sliderTitle.innerHTML = Page.Slider.activeSlide.dataset.title
        },

        activateSlide : ($index) => {

            // Remove the active states from slide and numbers
            Page.Slider.activeSlide.classList.remove('slide-active')
            Page.Slider.activeNumber.classList.remove('slider-number-active')

            // Store the new active slide
            Page.Slider.activeSlide  = Page.Slider.sliderTrack[$index];
            Page.Slider.activeNumber = Page.Slider.sliderNumbers[$index];

            // Activate the slide and the number
            Page.Slider.activeSlide.classList.add('slide-active')
            Page.Slider.activeNumber.classList.add('slider-number-active')

            Page.Slider.updateSliderTitle()

        },

        moveSliderWithNumbers : () => {
            Page.Slider.sliderNumbers.forEach(number => {
                number.addEventListener('click' , () => {
                    Page.Slider.activateSlide(number.value)
                })
            })
        },

        moveSliderForward : () => {
            if (Page.Slider.sliderIndex < Page.Slider.sliderTrack.length - 1) {
                Page.Slider.sliderIndex++;
            } else {
                Page.Slider.sliderIndex = 0;
            }

            Page.Slider.activateSlide(Page.Slider.sliderIndex)
        },

        moveSliderBackwards : () => {
            if (Page.Slider.sliderIndex > 0) {
                Page.Slider.sliderIndex--;
            } else {
                Page.Slider.sliderIndex = Page.Slider.sliderTrack.length - 1;
            }
            Page.Slider.activateSlide(Page.Slider.sliderIndex)
        },

        moveSliderForwardOnClick : () => {
            Page.Slider.nextButton.addEventListener('click' , () => { Page.Slider.moveSliderForward() })
        },

        moveSliderBackwardsOnClick : () => {
            Page.Slider.prevButton.addEventListener('click' , () => { Page.Slider.moveSliderBackwards() })
        },

        swipeEvents : () => {
            var hammerContainer = new Hammer(Page.Slider.container);
            hammerContainer.on('swiperight', (ev) => { console.log(hammerContainer); Page.Slider.moveSliderBackwards() });
            hammerContainer.on('swipeleft' , (ev) => { console.log(hammerContainer); Page.Slider.moveSliderForward() });
        }

    }

};

Page.liftoff()